module.exports = __webpack_public_path__ + "img/关于我们banner.ee29e50c.png";